// ─────────────────────────────────────────────────────────────
//  departments.js
//  Shared constants for departments and their positions.
//  Import wherever you need a department/position select.
// ─────────────────────────────────────────────────────────────

export const DEPARTMENTS = [
  "Software",
  "Marketing",
  "CEO",
  "COO",
  "HR",
  "Other",
];

export const POSITIONS_BY_DEPARTMENT = {
  Software: [
    "Frontend Developer",
    "Backend Developer",
    "UI/UX Designer",
  ],
  Marketing: [
    "SEO Specialist",
    "Content Creator",
    "Social Media Specialist",
    "Media Production",
    "Moderator",
    "Graphic Designer",
    "Art Director",
    "Media Buyer",
    "Ads Advertising",
  ],
  HR: [
    "HR",
  ],
  Other: [
    "Legal Affairs",
    "Accountant",
    "Secretary",
    "Office Boy",
  ],
  // CEO and COO have no positions (handled by role logic)
  CEO: [],
  COO: [],
};